module.exports = __webpack_public_path__ + "media/packs/images/bell-e8a38c17fae6c7262401192534116569.svg";